import { Id, retrieveListError } from "@planzone/dto";
import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return (listId: Id) =>
    present(
      repository.getList(listId).catch((e) =>
        Promise.reject({
          error: {
            ...retrieveListError,
            ...e,
          },
          listId,
        }),
      ),
    );
}

export type { Interactor };

export { createInteractor };
